import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, Inject, inject } from '@angular/core'

import { TranslateModule } from '@ngx-translate/core'
import { first, map, takeUntil, tap } from 'rxjs'

import { DestroyDirective } from '~/core/directives'
import { COMPANY_FACADE, ICompanyFacade } from '~/core/features'
import { EdgarInfoSummaryComponent } from '~/ui/edgar-info-summary'
import { LoadingComponent } from '~/ui/loading'

@Component({
  selector: 'app-edgar-report',
  templateUrl: './edgar-report.component.html',
  styleUrl: './edgar-report.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [DestroyDirective],
  imports: [AsyncPipe, TranslateModule, LoadingComponent, EdgarInfoSummaryComponent],
})
export class EdgarReportComponent {
  private readonly destroy$ = inject(DestroyDirective).destroy$

  constructor(@Inject(COMPANY_FACADE) public companyFacade: ICompanyFacade) {}

  getReport(): void {
    // TODO: refactor
    this.companyFacade.forecast$
      .pipe(
        first(),
        map(forecast => forecast!.company.ticker),
        tap(ticker => this.companyFacade.getForecastEdgar(ticker)),
        takeUntil(this.destroy$)
      )
      .subscribe()
  }
}
